var baseUrl = "http://localhost:4000";
// baseUrl = "https://whoyfzdjgl.execute-api.us-east-1.amazonaws.com/dev";
// baseUrl = "https://6533ava44m.execute-api.us-east-1.amazonaws.com/prod";
// var useMockData = true;
var useMockData = false;

// console.log("somto process.env.NODE_ENV", process.env.NODE_ENV);
// console.log("somto process.env.USE_TEST_STRIPE", process.env.USE_TEST_STRIPE);

// Uncomment line when doing production build of React in QA server, so the right API is hit
// baseUrl = "http://qa.fwdlook.com"; useMockData = false;

// Uncomment line when doing production build for production (S3)
if (process.env.NODE_ENV === "production") {
  // If we are using test Stripe payment, then we are deploying to DEV S3 bucket on AWS.
  // We eventually will be saving to DEV database
  if (process.env.USE_TEST_STRIPE) {
    baseUrl = "https://whoyfzdjgl.execute-api.us-east-1.amazonaws.com/dev";
    useMockData = false;
  } else {
    baseUrl = "https://6533ava44m.execute-api.us-east-1.amazonaws.com/prod";
    useMockData = false;
  }
}

// if (process.env.NODE_ENV === "production") {
//   useMockData = false;
// }

// Environment variables
export const BASE_URL = baseUrl;
export const USE_MOCK_DATA = useMockData;

// REDUCERS
// ReviewOrderPage/CustomerInfoForm
export const CREATE_ORDER_AND_CUSTOMER = "CREATE_ORDER_AND_CUSTOMER";
export const CREATE_ORDER_AND_CUSTOMER_SUCCESS =
  "CREATE_ORDER_AND_CUSTOMER_SUCCESS";
export const INITIATE_DOWNPAYMENT = "INITIATE_DOWNPAYMENT";
export const DOWNPAYMENT_FAIL = "DOWNPAYMENT_FAIL";
export const DOWNPAYMENT_SUCCESS = "DOWNPAYMENT_SUCCESS";
export const POLLING_ORDER_STATUS = "POLLING_ORDER_STATUS";
export const POLLING_REQUEST_FAIL = "POLLING_REQUEST_FAIL";
// export const SET_ORDER_ID = "SET_ORDER_ID";
export const POLLING_ORDER_STATUS_SUCCESS = "POLLING_ORDER_STATUS_SUCCESS";
// Emails
export const SENDING_CONFIRMATION_EMAIL = "SENDING_CONFIRMATION_EMAIL";
export const SENDING_CONFIRMATION_EMAIL_FAILURE =
  "SENDING_CONFIRMATION_EMAIL_FAILURE";
export const SENDING_CONFIRMATION_EMAIL_SUCCESSFUL =
  "SENDING_CONFIRMATION_EMAIL_SUCCESSFUL";

// Trips TODO, give search confirm its own reducer
export const FETCHING_SEARCH_CONFIRM_LOCATIONS =
  "FETCHING_SEARCH_CONFIRM_LOCATIONS";
export const FETCHING_SEARCH_CONFIRM_LOCATIONS_SUCCESSFUL =
  "FETCHING_SEARCH_CONFIRM_LOCATIONS_SUCCESSFUL";
export const FETCHING_SEARCH_CONFIRM_LOCATIONS_FAILED =
  "FETCHING_SEARCH_CONFIRM_LOCATIONS_FAILED";



// WEBPACK FOOTER //
// ./src/constants/index.js